var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25.2631579px",
    height: "30px",
    viewBox: "0 0 25.2631579 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "excel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.231,0 L25.263,6.336 L25.2631579,27.45408 C25.2631579,28.8601528 24.1233107,30 22.7172379,30 L2.54592,30 C1.13984721,30 6.16283464e-16,28.8601528 0,27.45408 L0,2.54592 C-1.72194254e-16,1.13984721 1.13984721,2.58291381e-16 2.54592,0 L19.231,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#3EB583",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BDEBD7",
    mask: "url(#mask-2)",
    x: 18.9473684,
    y: -5.17241379,
    width: 9.47368421,
    height: 11.3793103,
    rx: 1.27296
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "10.7350272 14.3729553 6.41560799 8.57142857 9.40108893 8.57142857 12.2277677 12.7241003 15.1814882 8.57142857 18.0716878 8.57142857 13.6569873 14.3729553 18.2940109 20.5408942 15.2767695 20.5408942 12.1642468 16.1439477 9.05172414 20.5714286 6.09800363 20.5714286"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.54c5456f2661de398c94d0eb228d1842.svg";
export { ForwardRef as ReactComponent };